import { Layer } from "react-map-gl/mapbox"

interface ThreeDLayerProps {
  opacity?: number
}

export const ThreeDLayer = ({ opacity = 0.6 }: ThreeDLayerProps) => {
  const paint: Record<string, unknown> = {
    "fill-extrusion-color": "#CFCFCF",
    "fill-extrusion-height": ["interpolate", ["linear"], ["zoom"], 15, 0, 15.05, ["get", "height"]],
    "fill-extrusion-base": ["interpolate", ["linear"], ["zoom"], 15, 0, 15.05, ["get", "min_height"]],
    "fill-extrusion-opacity": opacity,
  }

  return (
    <Layer
      type="fill-extrusion"
      minzoom={15}
      filter={["==", "extrude", "true"]}
      source-layer="building"
      id="three-d-layer"
      source="composite"
      paint={paint}
    />
  )
}
